(function () {
  window.initLaParfumerieLp = function () {
    var $ = window.jQuery;

    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initLaParfumerieLp');
      return;
    }

    function bindLoad(fn) {
      var run = function () {
        try {
          fn();
        } catch (e) {
          console.warn('[LP] initLaParfumerieLp bindLoad', e);
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        $(window).on('load', run);
      }
    }

    function safeTop(target) {
      try {
        var $el = target && target.jquery ? target : $(target);

        if (!$el || !$el.length) return 0;

        var o = $el.offset();

        return o ? o.top : 0;

      } catch (e) {
        return 0;
      }
    }


    /* --- block 1 --- */
    (function () {
      try {

        $(function () {

          // ========================================
          // ① 商品Slick
          // ========================================
          var $productSlider = $('.parfumerie-item__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false
          });


          // ========================================
          // ② 香りマトリクスをクリック
          // ========================================
          $('.fragrance-matrix__btn').on('click', function () {

            var index = $(this).data('index');

            // 商品Slickを対象の商品へ移動
            $productSlider.slick('slickGoTo', index);

            // active切り替え
            $('.fragrance-matrix__item').removeClass('is-active');

            $(this)
              .closest('.fragrance-matrix__item')
              .addClass('is-active');


            // ========================================
            // Slickエリアまでスクロール
            // announcement-bar + header分を考慮
            // ========================================

            var announcementHeight =
              $('.announcement-bar').outerHeight() || 0;

            var headerHeight =
              $('.header').outerHeight() || 0;

            var offset =
              announcementHeight + headerHeight;

            $('html, body').animate({
              scrollTop: $('#ParfumerieItem').offset().top - offset
            }, 500);

          });


          // ========================================
          // ③ 商品Slickを操作したとき
          // ========================================
          $productSlider.on(
            'afterChange',
            function (event, slick, currentSlide) {

              $('.fragrance-matrix__item')
                .removeClass('is-active');

              $('.fragrance-matrix__item[data-index="' + currentSlide + '"]')
                .addClass('is-active');

            }
          );


          // ========================================
          // ④ メールから直接アクセスした場合
          // ========================================
          var fragranceMap = {
            dor: 0,
            ljb: 1,
            is: 2,
            ios: 3,
            hw: 4
          };

          var hash = window.location.hash
            .replace('#', '')
            .toLowerCase();

          if (fragranceMap[hash] !== undefined) {

            var targetIndex = fragranceMap[hash];

            // ページ読み込み後に
            // 該当のマトリクスをクリック
            setTimeout(function () {

              $('.fragrance-matrix__btn')
                .eq(targetIndex)
                .trigger('click');

            }, 100);

          }


          // ========================================
          // ⑤ TKの商品Slick
          // ========================================
          var $tkSlider = $('.tk-item__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false
          });

        });

      } catch (e) {
        console.warn(
          '[LP] initLaParfumerieLp block 1',
          e
        );
      }
    })();


    /* --- block 2 --- */
    (function () {
      try {

        $('.accordion__wrapper .accordion').on('click', function (e) {

          e.preventDefault();

          var $wrapper =
            $(this).closest('.accordion__wrapper');

          $wrapper.toggleClass('open');

          $wrapper
            .find('.accordion-more')
            .stop(true, true)
            .slideToggle(500);

        });

      } catch (e) {
        console.warn(
          '[LP] initLaParfumerieLp block 2',
          e
        );
      }
    })();


    /* --- block 3 --- */
    (function () {
      try {

        var sizes = ['l', 's'];

        // =========================
        // Slick初期化
        // =========================
        function initSlider($target) {

          if ($target.hasClass('slick-initialized')) return;

          $target.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            swipe: true,
            infinite: false,
            dots: false,
            adaptiveHeight: true,

            responsive: [{
              breakpoint: 960,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }]
          });

          // SPでSlickの矢印を操作したときも
          // L/Sのactiveを連動
          $target.on(
            'afterChange',
            function (event, slick, currentSlide) {

              if ($(window).width() > 960) return;

              var size = sizes[currentSlide];

              var $panel =
                $target.closest('.lineup-panel-group');

              $panel
                .find('.size-filter li')
                .removeClass('active');

              $panel
                .find(
                  '.size-filter li[data-size="' + size + '"]'
                )
                .addClass('active');

            }
          );

        }


        // =========================
        // サイズ変更
        // =========================
        function changeSize(size) {

          var index = sizes.indexOf(size);

          var $panel =
            $('.lineup-panel-group.active');

          var $slider =
            $panel.find('.lineup__list');

          // Slickが初期化されていなければ初期化
          initSlider($slider);

          // Slick移動
          $slider.slick('slickGoTo', index);

          // サイズボタンのactive
          $panel
            .find('.size-filter li')
            .removeClass('active');

          $panel
            .find(
              '.size-filter li[data-size="' + size + '"]'
            )
            .addClass('active');

        }


        // =========================
        // 初期表示
        // =========================
        initSlider(
          $('.lineup-panel-group.active .lineup__list')
        );

        changeSize('l');


        // =========================
        // タブ切り替え
        // =========================
        $('.lineup-tab').on('click', function () {

          var index = $(this).index();

          var $next =
            $('.lineup-panel-group').eq(index);


          // タブactive切り替え
          $('.lineup-tab')
            .removeClass('active');

          $(this)
            .addClass('active');


          // パネルactive切り替え
          $('.lineup-panel-group')
            .removeClass('active');

          $next.addClass('active');


          // 次のSlickを初期化
          var $slider =
            $next.find('.lineup__list');

          initSlider($slider);


          // 非表示→表示したSlickの
          // レイアウトを再計算
          setTimeout(function () {

            $slider.slick('setPosition');

            // 初期状態をLにする
            changeSize('l');

          }, 50);

        });


        // =========================
        // サイズボタン（SPのみ）
        // =========================
        $('.size-filter li').on('click', function () {

          if ($(window).width() > 960) return;

          var size =
            $(this).data('size');

          changeSize(size);

        });


        // =========================
        // Next
        // =========================
        $('.lineup-next').on('click', function () {

          var $panel =
            $('.lineup-panel-group.active');

          var current =
            $panel
              .find('.size-filter li.active')
              .data('size');

          var index =
            sizes.indexOf(current);

          var next =
            sizes[(index + 1) % sizes.length];

          changeSize(next);

        });


        // =========================
        // Prev
        // =========================
        $('.lineup-prev').on('click', function () {

          var $panel =
            $('.lineup-panel-group.active');

          var current =
            $panel
              .find('.size-filter li.active')
              .data('size');

          var index =
            sizes.indexOf(current);

          var prev =
            sizes[
            (index - 1 + sizes.length) % sizes.length
            ];

          changeSize(prev);

        });


        // =========================
        // ページトップ・メニュー表示
        // =========================
        $(window).on('load scroll', function () {

          var pl = $(this).scrollTop();

          if (pl == 0) {
            $(".pagetop").css("display", "none");
          } else {
            $(".pagetop").css("display", "block");
          }


          var menu_pos =
            $("#SpecialKit").offset().top - 1;

          if (pl >= menu_pos) {
            $('.open-menu-out')
              .addClass("view");
          } else {
            $('.open-menu-out')
              .removeClass("view");
          }

        });


        // =========================
        // ページトップ表示
        // =========================
        $(window).on('load scroll', function () {

          var pl = $(this).scrollTop();

          if (pl == 0) {
            $(".pagetop").css("display", "none");
          } else {
            $(".pagetop").css("display", "block");
          }

        });


      } catch (e) {
        console.warn(
          '[LP] initLaParfumerieLp block 3',
          e
        );
      }
    })();


    /* inview: 動的読込後も表示する */
    (function () {
      try {

        var $els = $('.inview');

        if (!$els.length) return;

        $els.each(function () {

          var $el = $(this);

          if ($el.data('lpInviewBound')) return;

          $el.data('lpInviewBound', 1);

          $el.one(
            'inview',
            function (event, isInView) {

              if (isInView) {
                $(this)
                  .stop()
                  .animate({
                    opacity: 1
                  }, 500);
              }

            }
          );

        });

        $(window).trigger('scroll');

      } catch (e) { }

    })();

  };


  window.destroyMintySparkYuzuLp = function () {

    var $ = window.jQuery;

    if (!$) return;

    try {

      $('.slick-initialized').each(function () {
        $(this).slick('unslick');
      });

    } catch (e) { }


    try {

      document
        .querySelectorAll('.swiper')
        .forEach(function (el) {

          if (el.swiper) {
            el.swiper.destroy(true, true);
          }

        });

    } catch (e) { }


    $('.open-modal').off('click');

    $('.pagetop a').off('click');

  };

})();